import Swiper, {Navigation, Pagination, Keyboard, Autoplay} from 'swiper';
import 'lodash';
import {registerHtmlHook} from "../utils/htmlHooks";
import loadContents from './content-loader';

export default class SwiperComponent {

    swiperContainer  = '.swiper';
    swiperPagination = '.swiper-pagination';
    swiperButtonPrev = '.swiper-button-prev';
    swiperButtonNext = '.swiper-button-next';

    constructor(containerClassName) {
        this.containerClassName = containerClassName;
    }

    async handleSlideChange(swiper) {

        const activeSlide = swiper.slides[swiper.activeIndex];

        // if we have a data-load property, we should fetch tab content from url
        if (activeSlide) {
            if (activeSlide.dataset.load) {
                loadContents(activeSlide, () => {
                    window.setTimeout(() => swiper.update(), 100);
                });
            }
        }
    }

    // TODO: We should try to import spaceBetween from Bootstrap
    // TODO: Change data attributes to swiper json object in next step

    breakpoints(el) {

        return {
            0: {
                slidesPerView: el.dataset.slidesPerView,
                spaceBetween: 16
            },
            576: {
                slidesPerView: el.dataset.slidesPerViewSm,
                spaceBetween: 16
            },
            768: {
                slidesPerView: el.dataset.slidesPerViewMd,
                spaceBetween: 16
            },
            992: {
                slidesPerView: el.dataset.slidesPerViewLg,
                spaceBetween: 32
            },
            1200: {
                slidesPerView: el.dataset.slidesPerViewXl,
                spaceBetween: 32
            },
            1400: {
                slidesPerView: el.dataset.slidesPerViewXxl,
                spaceBetween: 32
            },
        };

    }

    freeMode(el) {

        return {
            enabled: el.dataset.freeMode,
            sticky: false,
        };

    }

    autoHeight(el) {

        if (_.isUndefined(el.dataset.autoHeight) || _.isEmpty(el.dataset.autoHeight)) {
            return false;
        }
        return el.dataset.autoHeight;

    }

    autoplay(el) {

        if (_.isUndefined(el.dataset.autoplay) || _.isEmpty(el.dataset.autoplay)) {
            return false;
        }

        return {
            delay: el.dataset.autoplay,
            disableOnInteraction: false
        };

    }

    loop(el) {

        return el.dataset.loop;

    }

    tabsEl(el) {
        return el.closest('.is-swiper-holder').querySelector('[data-tabs]');
    }

    pagination(id, element) {
        return {
            el: `${this.containerClassName}-outer-${id} ${this.swiperPagination}`,
            clickable: true,
            dynamicBullets: (element.querySelectorAll(".swiper-slide").length > (element.dataset.swiperDynamicBulletsThreshold ?? 5)),
        };
    }

    loadSwipers(elements) {

        elements.forEach((element) => {
            this.loadSwiper(element);
        });
    }

    loadSwiper(element) {

        let id = _.uniqueId();

        // Adding a nw selector to the swiper element
        element.classList.add(`${this.containerClassName}-outer-${id}`.substring(1));
        let swiperContainer = element.querySelector(this.swiperContainer);

        if (swiperContainer) {

            // Add css classes to swiper element
            swiperContainer.classList.add(`${this.containerClassName}-${id}`.substring(1));
            let swiperElement = element.querySelector(this.swiperContainer);

            let tabSwiper = null;

            if (this.tabsEl(element)) {

                // Add css classes to swiper tabs element
                element.closest('.is-swiper-holder').classList.add('-tabs');
                this.tabsEl(element).classList.add(`${this.containerClassName}-outer-${id}`.substring(1));

                tabSwiper = new Swiper(this.tabsEl(element).querySelector('.swiper'), {
                    modules: [Navigation, Pagination, Keyboard],
                    spaceBetween: 0,
                    freeMode: false,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    watchOverflow: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    threshold: 10,
                    autoHeight: this.autoHeight(this.tabsEl(element)),
                    observer: true,
                    observeParents: true,
                    breakpoints: this.breakpoints(this.tabsEl(element)),
                    navigation: {
                        prevEl: `${this.containerClassName}-outer-${id} ${this.swiperButtonPrev}`,
                        nextEl: `${this.containerClassName}-outer-${id} ${this.swiperButtonNext}`,
                    },


                })

            }


            let swiper = new Swiper(swiperElement, {

                // Configure Swiper to use modules
                modules: [Navigation, Pagination, Keyboard, Autoplay],

                // Responsive breakpoints
                breakpoints: this.breakpoints(element),

                // FreeMode
                freeMode: this.freeMode(element),

                // AutoHeight
                autoHeight: this.autoHeight(element),

                // Autoplay
                autoplay: this.autoplay(element),

                watchOverflow: true,

                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },

                // Infinity loop
                loop: this.loop(element),

                // If we need pagination
                pagination: this.pagination(id, element),

                // Navigation arrows
                navigation: {
                    prevEl: `${this.containerClassName}-outer-${id} ${this.swiperButtonPrev}`,
                    nextEl: `${this.containerClassName}-outer-${id} ${this.swiperButtonNext}`,
                },

                thumbs: {
                    swiper: tabSwiper
                },

                on: {
                    init: function (swiper) {

                        // config to clean up the event bindings
                        swiper.navigation?.destroy();
                        const breakpoint = swiper.getBreakpoint(swiper.params.breakpoints);
                        const currentBreakpoint = swiper.params.breakpoints?.[breakpoint];
                        const {navigation: currentBreakpointNavConfig} = currentBreakpoint || {};

                        if (!currentBreakpointNavConfig) {
                            return;
                        }

                        if (currentBreakpointNavConfig === true || currentBreakpointNavConfig?.enabled) {
                            swiper.navigation.init();
                            swiper.navigation.update();
                        }
                    },
                    activeIndexChange: this.handleSlideChange,
                    afterInit: (swiper) => {
                        this.handleSlideChange(swiper);
                    }
                }

            });
        }


    }

}

// Init new swiper

window.addEventListener('load', (event) => {
    let swiperComponent = new SwiperComponent('.is-swiper');
    swiperComponent.loadSwipers(document.querySelectorAll('.is-swiper'));
});


registerHtmlHook((container) => window.setTimeout(() => {
    let swiperComponent = new SwiperComponent('.is-swiper');
    swiperComponent.loadSwipers(container.querySelectorAll('.is-swiper'));
}, 300));
